
import { Component, Prop, Vue } from 'vue-property-decorator'

import News4 from '@/pages/index/components/MobileNews4.vue'
import { NewsMixinManager } from '@/pages/index/components/news-mixin/manager'
import { NewsMixinService } from '@/pages/index/components/news-mixin/service'
@Component({
  components: {
    News4
  }
})
export default class HorizontalMenu extends Vue {
  private manager = new NewsMixinManager(0, '', new NewsMixinService());
  private menuTitle = [
    { id: '23', title: '新闻动态', status: true },
    { id: '99', title: '资讯回顾', status: false },
    { id: '21', title: '技术工作', status: false },
    { id: '22', title: '法律法规', status: false }
  ]

  private id = '23'
  mounted () {
    this.manager.informationReviewService()
  }

  seeMore () {
    window.location.href = '/detailImagePage.html'
  }

  goLinkpage (url: string) {
    console.log(url)
    if (!url) { return }
    if (!url.includes('http://') && !url.includes('https://')) {
      url = 'https://' + url
    }
    window.open(url)
  }

  toggleHandler (item: any) {
    this.menuTitle.map((item: any) => {
      item.status = false
      return item
    })
    item.status = true
    this.id = item.id
  }
}
